<section class="main_section">
  <div class="total-container">
    <div class="header-section">
      <div class="create-text" *ngIf=" !data.edit">Add New Collection</div>
      <div class="create-text" *ngIf="data.edit">Update Collection</div>
      <div class="close-btn" (click)="closebutton()" *ngIf="srcWidth > 475">
        <img src="../../../../../../assets/images/close.svg" alt="">
      </div>
    </div>
    <div class="body-section">

      <div class="attachment-section">
        <div class="input-label"> Collection Image</div>

        <div class="profile-img ">
          <div class="attach-header">
            <ng-container *ngIf="nodeAttachements?.length == 0">
              <div class="fc_browse" *ngIf="nodeAttachements">
                <span class="attach-files-span" (click)="fileInput.click()">
                  <span class="plus">+</span>
                  Upload
                </span>
              </div>
            </ng-container>


          </div>
          <div class="image-box" *ngIf="nodeAttachements?.length > 0 && !pageLoader">
            <div class="image_box">
              <span class="fc_browse_btn" id="display_browse_btn" (click)="fileInput.click()">
                <span class="plus">+</span>
                Upload
              </span>
            </div>
          </div>

          <input id="vendorImage" type="file" name="myfile"
            accept="image/jpg,image/jpeg,image/gif,image/png,image/x-eps" (change)="updateContactImage($event)"
            class="pc-btn" id="browse_contact_image" #fileInput />
          <div class="addedImg">
            <ng-container *ngFor="let items of nodeAttachements; let i = index">
              <div *ngIf="items.attachmentType=='IMAGE'" class="image-container">
                <div class="uploadedImg">
                  <div class="image_name">
                    <img [src]="ds.bypassSecurityTrustUrl(items.url)" alt="" class="given-img">
                    <div class="button-delete-change" (click)="delete(i)">
                      <div class="delete_button">
                        <img src="assets/images/master/delete-icon.svg" alt="delete">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="items.attachmentType=='FILE'">
                <div class="pdf-files-changes">
                  <div class="person-details box-line">
                    <div class="icon">
                      <img src="../../../../../assets/images/invoice/pdf-icon.svg" alt="">
                    </div>
                  </div>
                  <div class="image-buttons">
                    <div class="button delete-change" (click)="delete(i)">
                      <div class="delete">
                        <img src="../../../../../assets/images/invoice/delete_invoice.svg" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <!-- </ng-container> -->
        </div>
      </div>
      <div class="product-image">
        Product images must be PNG or JPEG, recommended 1024 px by 1024 px or 1:1 aspect ratio.
      </div>

      <div class="lead-section content-box">
        <div class="invoice-info">
          <div class="input-box1">
            <div class="input-label">Collection Name<sup>*</sup></div>
            <mat-form-field class="full-width input_card" appearance="outline">
            <input
            matInput
          placeholder="Enter Collection Name"
           [(ngModel)]="CollectionData.collectionName"
           maxlength="50"
           #collectionNameInput="ngModel"
            name="collectionName"
            required
            />

  <!-- ✅ Character counter -->
  <mat-hint align="end">{{ CollectionData.collectionName?.length || 0 }}/50</mat-hint>

  <!-- ✅ Validation message -->
  <mat-error *ngIf="CollectionData.collectionName?.length > 50">
    Collection Name cannot exceed 50 characters.
  </mat-error>
</mat-form-field>

          </div>
        </div>

      </div>
      <div class="lead-section-description">
        <div class="invoice-info">
          <div class="content-box full">
            <div class="input-label">Description<sup>*</sup></div>
            <mat-form-field class="full-width-text input_card" appearance="outline">
              <input class="text-area" matInput [(ngModel)]="CollectionData.description"
                placeholder="Enter category description">
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="content-box full" style="margin-top: 0px;">
        <div class="input-label">
          Sub Industry
        </div>

        <mat-form-field class="full-width input_card" appearance="outline">
          <mat-select class="full-width2" [(ngModel)]="CollectionData.subIndustryId">
            <mat-option *ngFor="let option of ecomIndustry" [value]="option.subIndustryId"
              (click)="selectBusinessType(option)">
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="content-box full" style="margin-top: 0px;">
        <div class="input-label" style="margin-bottom: 5px;">
          Select Products
        </div>
        <div class="browse-prod">
          <!-- <div class="search-bar d-flex align-items-center">
            <mat-form-field class="sfull-width" appearance="outline" style="width: 100%;">
              <mat-icon matPrefix class="mat-search-icon">search</mat-icon>
              <input matInput placeholder="Search by name" style="height: 34px !important;"
                [value]="getSelectedProductNames()" readonly />
            </mat-form-field>
          </div> -->
          <div class="d-flex align-items-center gap-2 w-100">
            <mat-form-field appearance="outline" style="width: 100%;">
              <input matInput type="text" placeholder="Search products" [formControl]="searchControl">
            </mat-form-field>
            <div class="delete_all" (click)="deleteAllChips()">Select All</div>
          </div>
          <div class="middle-container">
            <div class="middle" *ngFor="let product of filteredProducts">
              <mat-checkbox #checkboxRef class="custom-checkbox"
                [checked]="addedProductIds.includes(product.itemId)" (change)="addProduct(checkboxRef,product)">
              </mat-checkbox>

              <img *ngIf="product.itemImages?.[0]?.imgUrl" [src]="product.itemImages[0].imgUrl" class="prod-img"
                alt="User uploaded image">

              <img *ngIf="!product.itemImages?.[0]?.imgUrl"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5GLRiruBbo9dQ85FU7cY9Mt9LCQvridJJV5472zMbU0ZzX6jNUPnnh3J5_UShU-2lWhg&usqp=CAU"
                class="prod-img" alt="Default image">

              <p class="prod-name">{{ product.name }}</p>
            </div>
          </div>

          <!-- <div (click)="openDialog()" class="browse">
            Browse <span><mat-icon class="right-arrow">keyboard_arrow_right</mat-icon></span>
          </div> -->
        </div>
        <div class="d-flex align-items-center mt-2 gap-2">
          <div class="items_chips d-flex align-items-center gap-2" *ngIf="productsChips.length>0"
>
            <div class="items d-flex align-items-center justify-content-center"
              *ngFor="let product of productsChips;let i = index">
              <div class="chips">
                {{product.name}}
              </div>
              <div class="item_delete d-flex align-items-center justify-content-center" (click)="deleteChip(product,i)">
                <mat-icon class="close_item">close</mat-icon>
              </div>
            </div>
          </div>
        </div>

      </div>




    </div>
    <div class="footer-section">
      <div class="cancle-section">
        <button class="cancle" (click)="closebutton()">Cancel</button>
      </div>
      <div class="createCont-section">
        <button class="create-contact" (click)="createCollections()" *ngIf="!data.edit">
          <span *ngIf="submitLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
          <span *ngIf="!submitLoader">+ Add Collection</span>
        </button>

        <button class="create-contact" (click)="createCollections()" *ngIf="data.edit">
          <span *ngIf="submitLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
          <span *ngIf="!submitLoader">Update Collection</span>
        </button>
      </div>

    </div>

  </div>


</section>